import {useContext} from "react";
import {CheckpointsListContext} from "./CheckpointsListContext";

const useCheckpointsList = () => {
    return useContext(CheckpointsListContext)
}

export default useCheckpointsList